module.exports = __webpack_public_path__ + "img/6.57da0c5e.jpg";